/**
 * 区号相关方法
 */

import { get, localStorageManager } from '~/utils';
import { LOCAL_STORAGE, LOCAL_STORAGE_MIGRATE } from '~/constants';
import { getChinaCode } from '@libs/shared';

/**
 * 通过手机号获取区号（手机号不带区号时取缓存内的，缓存内没有时取列表第一个）
 *
 * @param value 手机号
 * @param needCache 是否有缓存
 * @param phoneDelimiter 手机号和区号的分隔符，默认'-'
 */
export const getCodeByValue = (value: string, needCache?: boolean, phoneDelimiter = '-') => {
    const defaultAreaCode = needCache
        ? localStorageManager.getItemWithMigrate({
              oldKey: LOCAL_STORAGE.SIGN_IN.PHONE_AREA,
              newKey: LOCAL_STORAGE_MIGRATE.SIGN_IN_PHONE_AREA
          })
        : undefined;
    // 获取区号列表中的第一个区号
    const firstAreaCode = get(
        window.jdy_config,
        'calling_code_list.0.children.0.value',
        getChinaCode()
    );
    if (value?.indexOf(phoneDelimiter) >= 0) {
        return value.split(phoneDelimiter)[0];
    }
    return defaultAreaCode || firstAreaCode;
};
